import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import LocaleStrings from "Languages";
import { Field, reduxForm, reset, change } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { IMAGE_PATH, COMMON_FAIL_MESSAGE, validateEmail } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  BaseComponent,
  LABEL_POSITION_TOP,
  required,
  noSpecialChar,
  email,
  number,
  alphaNumeric,
  phoneNumber,
  maxLength,
  minLength,
  minValue,
  maxValue,
  trim,
} from "BaseComponent";
import { confirmAlert } from "react-confirm-alert";
import { bindActionCreators } from "redux";
import { knowEventcode } from "TemplatesAction";

import ConnectDomain from "../wizard/connectdomain";

import {
  showConnectDomainModal,
  saveConnectDomainData,
  saveOptionStateDomains,
  fetchWebsiteModule,
  fetchSiteDetails,
  updateDomain,
  deployWebsite,
  fetchTemplateModulepath,
  redeployFunction,
} from "../../actions";

class Domains extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = {
      loading: false,
      disabledCheckAvailability: true,
      disabledUpdateDomain: true,

      eventifydomainname: "",
      showURL: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.actions.knowEventcode(this.props.session);

      this.props.actions.fetchSiteDetails(this.props.session);

      let { siteDetails } = this.props;

      let domain_name = "";
      if (
        siteDetails &&
        siteDetails.resource &&
        !_.isEmpty(siteDetails.resource) &&
        siteDetails.resource[0].domain_name
      ) {
        domain_name = siteDetails.resource[0].domain_name;
      }

      let website_subdomain = "";
      if (
        siteDetails &&
        siteDetails.resource &&
        !_.isEmpty(siteDetails.resource) &&
        siteDetails.resource[0].website_subdomain
      ) {
        website_subdomain = siteDetails.resource[0].website_subdomain;
      }

      if (domain_name) {
        this.props.actions.saveOptionStateDomains({
          useeventifyCheck: false,
          connectownCheck: true,
        });
        this.props.actions.saveConnectDomainData({
          values: { userdomainname: domain_name },
          isconnected: true,
        });
      } else {
        this.props.actions.saveOptionStateDomains({
          useeventifyCheck: true,
          connectownCheck: false,
        });
        this.setState({ showURL: true });
        this.setState({ eventifydomainname: website_subdomain });
      }

      this.props.actions.fetchWebsiteModule(this.props.session);

      let { connectDomainData } = this.props;
      if (connectDomainData && !_.isEmpty(connectDomainData)) {
        this.props.actions.saveConnectDomainData(connectDomainData);
      } else {
        this.props.actions.saveConnectDomainData({
          values: {},
          isconnected: false,
        });
      }
    }, 1000);
  }

  onSubmitForm(values) {
    // let { session, siteDetails } = this.props;

    // this.setState({ loading: true });

    // let { connectDomainData, optionStateDomains } = this.props;
    // let resourceObj = {};

    // if (connectDomainData.isconnected && values.option != "useeventify") {
    //     resourceObj = { domain_name: connectDomainData.values.userdomainname, website_subdomain: session.eventname.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() }
    // }
    // else {
    //     resourceObj = { domain_name: null, website_subdomain: values.eventifydomainname };
    //     this.props.actions.saveConnectDomainData({ values: {}, isconnected: false });
    // }

    // this.props.actions.fetchTemplateModulepath(session, siteDetails.resource[0].templateid);

    // setTimeout( () => {

    // }, 100);

    // let { eventcode, templateModulepath } = this.props;

    // let deployParams = {
    //     eventcode: eventcode,
    //     template: templateModulepath,
    //     subdomain: connectDomainData.isconnected && values.option != "useeventify" ? session.eventname.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() : values.eventifydomainname,
    //     // metakeywords: metakeywords,
    //     // metadescription: metadescription,
    //     // adminemail: adminemail,
    //     // adminpass: adminpass,
    // };

    // setTimeout(() => {

    //     this.props.actions.updateDomain(session, resourceObj, (res) => {
    //         if (res.success) {
    //             this.setState({ loading: false });

    //             this.props.actions.showSuccess("Domain Updated successfully!");
    //             this.props.actions.fetchWebsiteModule(this.props.session);

    //             // this.props.actions.deployWebsite(session, deployParams, (resDeploy) => {

    //             //     if(resDeploy.success){
    //             //         this.setState({showDeployLoadingMsg: false})
    //             //         this.setState({showDeployLoadedMsg: true})
    //             //         this.setState({ loading: false });
    //             //         this.props.showSuccess("Website deployed successfully!");
    //             //         this.props.fetchSiteDetails(this.props.session);
    //             //         this.close();
    //             //         setTimeout(() => {
    //             //             this.redirectToDashboard();
    //             //             this.reset();
    //             //         }, 100);
    //             //     }
    //             //     else{

    //             //         this.setState({ loading: false });
    //             //         this.props.showError(COMMON_FAIL_MESSAGE);
    //             //     }

    //             // })
    //         }
    //         else {

    //             this.setState({ loading: false });
    //             this.props.actions.showError(COMMON_FAIL_MESSAGE);
    //         }

    //     });
    // }, 1);

    let { connectDomainData, session } = this.props;
    let redeployData = {};

    if (connectDomainData.isconnected && values.option != "useeventify") {
      redeployData = {
        domain_name: connectDomainData.values.userdomainname,
        website_subdomain: session.eventname
          .replace(/[^a-zA-Z0-9]/g, "")
          .toLowerCase(),
      };
    } else {
      redeployData = {
        domain_name: null,
        website_subdomain: values.eventifydomainname,
      };
      // this.props.actions.saveConnectDomainData({ values: {}, isconnected: false });
    }

    this.props.actions.redeployFunction({
      redeploy: true,
      from: "domain",
      data: redeployData,
    });

    setTimeout(() => {
      this.redirectToWizard();
    }, 100);
  }

  redirectToWizard = () => {
    var path = "wizard";
    this.props.history.push(`/dashboard/website/${path}`);
  };

  openConnectDomainModal = () => {
    this.props.actions.showConnectDomainModal({ showModal: true });
  };

  renderFieldRadio(field) {
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    var labelClasses =
      field.label === "Connect your own domain"
        ? "control-label-top col-sm-12 mt-40"
        : "control-label-top col-sm-12";

    return (
      <div className={divClassName}>
        <div className={labelClasses}>
          <label
            className="custom-container-radio liveqa-label"
            style={{ marginBottom: 5, color: "#767988", fontWeight: "bold" }}
          >
            {field.label} <br /> {field.labelDescription}
            <input {...field.input} type={field.type} checked={field.checked} />
            <span className="radiomark"></span>
          </label>

          {!field.showButton && field.label === "Connect your own domain" ? (
            <div className="col-md-12 text-left">
              <Button
                className="btn-custom-blue ml-10 mt-20"
                disabled={!field.checked}
                onClick={field.onButtonClick}
              >
                Connect Domain
              </Button>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  onOptionChange = (e) => {
    let clickedValue = e.target.value;
    if (clickedValue === "useeventify") {
      this.props.actions.saveOptionStateDomains({
        useeventifyCheck: true,
        connectownCheck: false,
      });
    } else {
      this.props.actions.saveOptionStateDomains({
        connectownCheck: true,
        useeventifyCheck: false,
      });
      // this.handlePartialUpdate();
    }
  };

  renderFieldText(field) {
    var { labelposition } = field;
    var divClassName = `row form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label-top col-sm-12 ml-25";
    var inputClasses = "col-sm-12 col-sm-offset-0 ml-25  d-flex";
    var noteClasses = "col-sm-12 col-sm-offset-0 text-muted-custom ml-25";

    return (
      <div className={divClassName}>
        <label className={labelClasses} style={{ color: "#767988" }}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            disabled={field.disabled}
            min={field.min ? field.min : ""}
            max={field.max ? field.max : ""}
            style={{ width: "90%" }}
          />
          {/* <div className="text-help label-text-help">{field.meta.touched ? field.meta.error : ''}</div> */}

          <Button
            className="btn-custom-blue-inside-input"
            style={{ marginLeft: -154, marginTop: 2 }}
            disabled={field.disabledCheckAvailability}
            onClick={field.onButtonClick}
          >
            Check Availability
          </Button>
        </div>
        <div className="text-help label-text-help ml-40">
          {field.meta.touched ? field.meta.error : ""}
        </div>

        <div className={noteClasses}>
          <p>{field.note}</p>
        </div>
      </div>
    );
  }

  handleChange = (event, newValue, previousValue, name) => {
    let { siteDetails } = this.props;
    let website_subdomain = "";
    if (
      siteDetails &&
      siteDetails.resource &&
      !_.isEmpty(siteDetails.resource) &&
      siteDetails.resource[0].website_subdomain
    ) {
      website_subdomain = siteDetails.resource[0].website_subdomain;
    }

    if (newValue != website_subdomain) {
      this.setState({ disabledCheckAvailability: false });
      this.setState({ showURL: false });
      this.setState({ eventifydomainname: newValue });
    } else {
      this.setState({ disabledCheckAvailability: true });
      this.setState({ showURL: false });
      this.setState({ eventifydomainname: "" });
    }
  };

  showURL = () => {
    this.setState({ showURL: true });
    this.setState({ disabledUpdateDomain: false });
  };

  handlePartialUpdate = () => {
    this.props.updateField("TemplatesDomainsForm", "eventifydomainname", "");
  };

  checkAvailability = (e) => {
    let { websiteModule } = this.props;
    let { eventifydomainname } = this.state;

    let filter = _.filter(websiteModule.resource, [
      "website_subdomain",
      eventifydomainname,
    ]);

    if (filter.length) {
      confirmAlert({
        title: "Domain Not Available",
        message:
          'Sorry! The domain name "' +
          eventifydomainname +
          '" already exist. Please try with a different name.',
        confirmLabel: "",
        cancelLabel: "Close",
        buttons: [
          {
            label: "",
            onClick: () => {},
          },
          {
            label: LocaleStrings.button_close,
            onClick: () => {
              // this.props.reset();
              this.handlePartialUpdate();
              this.setState({ disabledCheckAvailability: true });
              this.setState({ disabledUpdateDomain: true });
            },
          },
        ],
      });
    } else {
      this.showURL();
    }
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      editMode,
      initialValues,
      connectDomainModal,
      connectDomainData,
      optionStateDomains,
      siteDetails,
      deviceSize,
    } = this.props;

    let disabled = false;
    if (connectDomainData.isconnected) {
      disabled = !connectDomainData.isconnected;
    } else {
      disabled =
        pristine || invalid || submitting || this.state.disabledUpdateDomain;
    }

    return (
      <div
        className="panel-body scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        {connectDomainModal.showModal === true ? <ConnectDomain /> : ""}
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <div className="row" style={{ width: "70%" }}>
            <div className="col-md-12">
              <label className="heading-theme-text-color">
                Add a new domain
              </label>

              <div
                className="col-md-12 p-15"
                style={{
                  border: "solid 1px #A9ABB5",
                  borderRadius: 10,
                }}
              >
                <Field
                  name="option"
                  label="Use Eventify Domain"
                  labelDescription="(You can not change the Eventify sub-domian once set)"
                  component={this.renderFieldRadio}
                  type="radio"
                  value="useeventify"
                  onChange={this.onOptionChange.bind(this)}
                  checked={
                    optionStateDomains && !_.isEmpty(optionStateDomains)
                      ? optionStateDomains.useeventifyCheck
                      : true
                  }
                />

                <Field
                  name="eventifydomainname"
                  label={"Domain Name"}
                  placeholder={"ex: techshow2019"}
                  note={""}
                  type="text"
                  mandatory="true"
                  component={this.renderFieldText}
                  disabled={
                    optionStateDomains && !_.isEmpty(optionStateDomains)
                      ? !optionStateDomains.useeventifyCheck
                      : false
                  }
                  normalize={trim}
                  disabledCheckAvailability={
                    this.state.disabledCheckAvailability
                  }
                  onChange={(event, newValue, previousValue, name) =>
                    this.handleChange(event, newValue, previousValue, name)
                  }
                  onButtonClick={(e) => this.checkAvailability(e)}
                />

                {/* This div is used for listing paragraphs */}
                {this.state.showURL &&
                optionStateDomains &&
                !_.isEmpty(optionStateDomains) &&
                optionStateDomains.useeventifyCheck ? (
                  <div className="form-group">
                    <label
                      className="control-label-top col-sm-12 ml-25"
                      style={{ color: "#9699A5" }}
                    >
                      Website URL
                    </label>
                    <label
                      className="control-label-top col-sm-12 ml-25"
                      style={{ color: "#6a54c9" }}
                    >
                      {"https://" +
                        this.state.eventifydomainname +
                        ".eventify.io"}
                    </label>
                  </div>
                ) : (
                  ""
                )}

                <Field
                  name="option"
                  label="Connect your own domain"
                  labelDescription="(Make your site more professional, with your own branded domain name)"
                  component={this.renderFieldRadio}
                  type="radio"
                  value="connectown"
                  onChange={this.onOptionChange.bind(this)}
                  checked={
                    optionStateDomains && !_.isEmpty(optionStateDomains)
                      ? optionStateDomains.connectownCheck
                      : false
                  }
                  // checked={domain_name ? true : false }
                  onButtonClick={this.openConnectDomainModal}
                  showButton={connectDomainData.isconnected}
                />

                {connectDomainData.isconnected ? (
                  <div className="form-group">
                    {optionStateDomains &&
                    !_.isEmpty(optionStateDomains) &&
                    optionStateDomains.connectownCheck ? (
                      <div className="ml-25">
                        <label
                          className="control-label-top col-sm-12"
                          style={{ color: "#9699A5" }}
                        >
                          Connected domain
                        </label>
                        <label
                          className="control-label-top col-sm-12"
                          style={{ color: "#5A97EF" }}
                        >
                          {"https://" + connectDomainData.values.userdomainname}
                        </label>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="col-md-12 text-left">
                      <Button
                        className="btn-custom-blue ml-20 mt-20"
                        disabled={
                          !(
                            optionStateDomains &&
                            !_.isEmpty(optionStateDomains) &&
                            optionStateDomains.connectownCheck
                          )
                        }
                        onClick={(e) => this.openConnectDomainModal()}
                      >
                        Reconnect Domain
                      </Button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-md-12 text-center">
                  <Button
                    className="btn-custom-blue mt-70 mb-10"
                    loading={this.state.loading}
                    disabled={disabled}
                    type="submit"
                  >
                    {" "}
                    Update Domain And Re-Deploy{" "}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var option = values["option"];
  var eventifydomainname = values["eventifydomainname"];

  if (option === "useeventify") {
    if (!eventifydomainname || eventifydomainname.trim() === "") {
      errors["eventifydomainname"] = "Required";
    }
  }

  return errors;
}

var mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      showError,
      showSuccess,
      showConnectDomainModal,
      saveConnectDomainData,
      saveOptionStateDomains,
      fetchWebsiteModule,
      fetchSiteDetails,
      updateDomain,
      knowEventcode,
      deployWebsite,
      fetchTemplateModulepath,
      redeployFunction,
    },
    dispatch
  ),
  updateField: (form, field, newValue) =>
    dispatch(change(form, field, newValue)),
});

function mapStateToProps(state) {
  var initVals = null;
  var toEdit = false;

  if (
    state.siteDetails &&
    state.siteDetails.resource &&
    !_.isEmpty(state.siteDetails.resource) &&
    state.siteDetails.resource[0].domain_name
  ) {
    initVals = {
      option: "connectown",
      userdomainname: state.siteDetails.resource[0].domain_name,
      eventifydomainname: "",
    };
    toEdit = true;
  } else if (
    state.siteDetails &&
    state.siteDetails.resource &&
    !_.isEmpty(state.siteDetails.resource) &&
    state.siteDetails.resource[0].website_subdomain
  ) {
    initVals = {
      option: "useeventify",
      userdomainname: undefined,
      eventifydomainname: state.siteDetails.resource[0].website_subdomain,
    };
    toEdit = true;
  }

  return {
    session: state.session,
    initialValues: initVals,
    editMode: toEdit,
    connectDomainModal: state.connectDomainModal,
    connectDomainData: state.connectDomainData,
    optionStateDomains: state.optionStateDomains,
    websiteModule: state.websiteModule,
    siteDetails: state.siteDetails,
    eventcode: state.eventcode,
    templateModulepath: state.templateModulepath,
    redeploy: state.redeploy,
    deviceSize: state.deviceSize,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "TemplatesDomainsForm",
    enableReinitialize: true,
    // keepDirtyOnReinitialize: true
  })(Domains)
);
